import { writable } from 'svelte/store';
export const namesStore = writable('');
